// Shared presentation helpers for the environmental pages (ISO 14001): record-type and
// objective-status labels. The record-type and objective-status PILLS are StatusPill at the call sites
// (design system Session 7a): a record type is a grey category pill, and an objective status reads the
// registry's `objective` domain.
import type { EnvironmentalRecordType, ObjectiveStatus } from "../../lib/api";

export const RECORD_TYPE_LABEL: Record<EnvironmentalRecordType, string> = {
  waste_disposal: "Waste disposal",
  environmental_incident: "Incident",
  near_miss: "Near miss",
  fuel_consumption: "Fuel consumption",
  other: "Other",
};

export const OBJECTIVE_STATUS_LABEL: Record<ObjectiveStatus, string> = {
  on_track: "On track",
  at_risk: "At risk",
  achieved: "Achieved",
  missed: "Missed",
};

// Records that are not incidents/near-misses (waste, fuel, other) live on the "Waste and
// resources" tab; incidents and near misses on the "Incidents" tab. Nothing is hidden.
export function isIncidentType(type: EnvironmentalRecordType): boolean {
  return type === "environmental_incident" || type === "near_miss";
}
